export default __webpack_public_path__ + "static/media/AuctionAnim-BidClose.e6cfe001.mp4";